import { useAuthStore } from "@roman/shared/store/auth.store";

export const isUserLoggedIn = () => {
  return useAuthStore((state) => state.authState === "authenticated");
};
